import { Dispatch } from "redux";
import { setLoading } from "./global";
import MediaService from "service/Media";
import { showMessage } from "utilities/helper";
import { MediaPayloadTypes } from "utilities/types/Media";

export const getAllMedias = () => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await MediaService.getAllMedias();

    dispatch(setLoading(false));
    dispatch({ type: "SET_MEDIA", value: data.media });
  } catch (err: any) {
    dispatch(setLoading(false));
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const storeMedia =
  (form: MediaPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await MediaService.storeMedia(payload);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllMedias() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateMedia =
  (mediaId: string, form: MediaPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await MediaService.updateMedia(mediaId, payload);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllMedias() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteMedia =
  (mediaId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await MediaService.deleteMedia(mediaId);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });

      dispatch(getAllMedias() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
